// eslint-disable-next-line import/no-extraneous-dependencies
import { Amplify } from 'aws-amplify';

console.log('AWS Amplify config initialized');

const REGION = 'eu-central-1';

// eslint-disable-next-line no-unused-vars
const EVENT_URL =
  'https://6gb3unnkwzh2ribxssrmimo46a.appsync-api.eu-central-1.amazonaws.com/event';
// eslint-disable-next-line no-unused-vars
const API_KEY = 'da2-gpzwexnvhvc3pcmyrfczpdipnu';

// eslint-disable-next-line no-unused-vars
const EVENT_UAT_URL =
  'https://gcxacglftjavvaixd2gaqexv6m.appsync-api.eu-central-1.amazonaws.com/event';
// eslint-disable-next-line no-unused-vars
const API_KEY_UAT = 'da2-hn4rtgkevbfddobbaqqo5r7zgm';

// eslint-disable-next-line no-unused-vars
const EVENT_PROD_URL =
  'https://f6prhgs53zhjxgnvaiygvuek4a.appsync-api.eu-central-1.amazonaws.com/event';
// eslint-disable-next-line no-unused-vars
const API_KEY_PROD = 'da2-vyt7ziw3azduvox3gadalu4eum';

const AMPLIFY_ENDPOINT = process.env.VUE_APP_RS_AMPLIFY_URL;
const AMPLIFY_API_KEY = process.env.VUE_APP_RS_AMPLIFY_API_KEY;

Amplify.configure({
  API: {
    Events: {
      endpoint: AMPLIFY_ENDPOINT,
      region: REGION,
      defaultAuthMode: 'apiKey',
      apiKey: AMPLIFY_API_KEY,
    },
  },
});
